import SvgSprite from "championship/src/components/Utils/SvgSprite";
import React from 'react'
import './style.css'

import { currentTabAtom, getModel, getModelSchema } from "../model";
import { useAtom } from "@reatom/npm-react";
import { motion } from "motion/react";

const transition = { 
    type: 'spring', 
    stiffness: 1000, 
    damping: 50, 
    mass: 1 
}

function TabHeader({ ctx, separator, model }) {
    // atom
    const [current_tab_key, setTab] = useAtom(currentTabAtom)
    const tab_model = getModel(model)
    const tab = tab_model.schema
    const [tab_state, setTabState] = useAtom(tab_model.atom)
    const [prev_tab_state, setPrevTabState] = useAtom(tab_model.schema.prev_tab_atom)

    const isPresent = true

    const animations = {
        layout: true,
        initial: 'out',
        style: {
        //   color: color.hex(),
        //   position: isPresent ? 'relative' : 'absolute'
        //   position: isPresent ? 'static' : 'absolute'
        },
        animate: isPresent ? 'in' : 'out',
        // whileTap: 'tapped',
        variants: {
        //   in: { scaleY: 1, opacity: 1, zIndex: 0 },
        //   out: { scaleY: 0, opacity: 0, zIndex: -1 },
          in: { scaleY: 1, opacity: 1 },
          out: { scaleY: 0, opacity: 0, transition: { duration: 0.1 } },
        //   exit: { scaleY: 0, opacity: 0 },
        //   tapped: { scale: 0.98, opacity: 0.5, transition: { duration: 0.1 } }
        },
        onAnimationComplete: () => !isPresent && safeToRemove(),
        transition
        
    }

    
    return (
        <motion.div 
            exit={{opacity: 0}}
            {...animations}

            key={tab.key} 
            className={`
                reactive-form-tab-headers-item 
                ${tab.key==current_tab_key ? '-active' : ''}
                ${tab_state.is_done ? '-done': ''}
                ${!prev_tab_state.is_done ? '-disabled': ''}
                `} 
                onClick={() => setTab((k) => tab.key)}
            >
            <div class="svg-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle class="icon-part icon-part-circle" cx="12" cy="12" r="11.5" fill="white" />
                    <path class="icon-part icon-part-check" d="M16.4006 8.69946L10.3506 14.7495L7.60059 11.9995" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="reactive-form-tab-headers-item__collider"></div>
            <div class="reactive-form-tab-headers-item__title">
                {tab.label}
            </div>
            {separator && (
                <div class="reactive-form-tab-headers-item__separator"></div>
            )}
        </motion.div>
    )
}

export default TabHeader;